<template>
  <div class="row m-0 h-100">
    <div class="col-5 p-0 bg h-100">
      <div class="row m-0 mt-5 pt-5">
        <div class="col-12">
          <h3>HOW TO PLAY</h3>
        </div>
        <div class="col-2 mt-3 pt-1 pr-0 mb-3">
          <div class="border_white"></div>
        </div>
      </div>
       <div class="row m-0">
        <div class="col-2 mt-4 mb-3">
          <img src="../assets/images/time.png" class="img-fluid">
        </div>
        <div class="col-12 text_white">
          You have 90 seconds to find your 3 unique icons using the paddle given to you
        </div>
        <div class="col-2 mt-5 mb-3">
          <img src="../assets/images/hand.png" class="img-fluid">
        </div>
        <div class="col-12 text_white">
          Once you spot your icon, you need to select which colour block the icon is found in
        </div>
        <div class="col-2 mt-5 mb-3">
          <img src="../assets/images/trophy.png" class="img-fluid">
        </div>
        <div class="col-12 text_white">
          Top 3 players with the fastest time will win the following prizes
          <ul>
            <li>1st Prize - Advanced driving course and 3 vouchers worth R300</li>
            <li>2nd Prize – GOOGLE HOME and 2 vouchers worth R200</li>
            <li>3rd Prize – Dash cam and a voucher worth R100</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-7 h-100 logo_bg">
      <div class="row m-0 mt-5 pt-5 justify-content-center">
        <div class="col-5 p-0">
          <img src="../assets/images/intro_img.png" class="img-fluid">
        </div>
        <div class="col-12 mt-4">
          <img src="../assets/images/intro_img2.png" class="img-fluid">
        </div>
      </div>
      <div class="row justify-content-end abs">
        <div class="col-4">
          <div class="row m-0">
            <div class="col-12 text-right">
              ARE YOU READY?
            </div>
            <div class="col-12 text-right mt-3">
              <button @click="submit()" class="btn btn-gradient pl-5 pr-5">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  methods: {
    submit () {
      this.$router.push('/game')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fixed_top {
  position: fixed;
  top: 0;
}
.logo_bg {
  background-image: url("../assets/images/bg_logo.png");
  background-size: contain;
  background-position: 0px -40vh;
  background-repeat: no-repeat;
}
.bg {
/*   background-image: url('../assets/images/side_bg.png'); */
  background: -webkit-linear-gradient(45deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
  background-size: cover;
}
.border_gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 75%);
  padding: 1px 0;
}
.border_white {
  background: #fff;
  padding: 1px 0;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-control {
  border: none;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.abs {
  position: absolute;
  bottom: 3vh;
  width: 100%;
}
.btn-gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 95%);
  border-radius: 0;
  border: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue